import { Location as URL } from 'history';
import { get } from 'lodash';

import {
  LoginResponse,
  SessionLogoutPayload,
  SignupResponse,
  UserInfo,
} from '../../services/auth';
import { ActionInterface } from '../../utils/redux';
import { SessionActions } from './SessionActions';
import SessionState, { SessionStateInterface } from './state';

const INITIAL_STATE = new SessionState();

function SessionReducer(
  state = INITIAL_STATE,
  action: ActionInterface<SessionActions>
): SessionStateInterface {
  switch (action.type) {
    case SessionActions.deleteSession:
      return deleteSession(state, action);
    case SessionActions.setLoginRedirect:
      return setRedirect(state, action);
    case SessionActions.createAccountSuccess:
      return successCreateAccount(state, action);
    case SessionActions.createAccountStart:
      return startCreateAccount(state);
    case SessionActions.createAccountError:
      return errorCreateAccount(state, action);
    case SessionActions.getUserInfoStart:
      return startGetCurrentUserInfo(state);
    case SessionActions.getUserInfoSuccess:
      return successGetCurrentUserInfo(state, action);
    case SessionActions.getUserInfoError:
      return errorGetCurrentUserInfo(state, action);
    case SessionActions.pinLoginSuccess:
      return successPinLogin(state, action);
    case SessionActions.pinLoginStart:
      return startPinLogin(state);
    case SessionActions.pinLoginError:
      return errorPinLogin(state, action);
    default:
      return state;
  }
}

export default SessionReducer;

function setRedirect(
  state: SessionStateInterface,
  action: ActionInterface<SessionActions, URL>
) {
  return { ...state, redirectTo: action.payload };
}

function deleteSession(
  state: SessionStateInterface,
  action: ActionInterface<SessionActions, SessionLogoutPayload>
) {
  return { ...INITIAL_STATE, redirectTo: state.redirectTo, ...action.payload };
}
function successCreateAccount(
  state: SessionStateInterface,
  action: ActionInterface<SessionActions, SignupResponse>
) {
  return {
    ...state,
    customer: get(action.payload, 'user', undefined),
    error: undefined,
    expired: false,
    loading: false,
  };
}
function startCreateAccount(state: SessionStateInterface) {
  return { ...state, error: undefined, expired: false, loading: true };
}
function errorCreateAccount(
  state: SessionStateInterface,
  action: ActionInterface<SessionActions>
) {
  return { ...state, error: action.payload, loading: false };
}

function successGetCurrentUserInfo(
  state: SessionStateInterface,
  action: ActionInterface<SessionActions, UserInfo>
) {
  return {
    ...state,
    ...action.payload,
    expired: false,
    redirectTo: undefined,
  };
}
function startGetCurrentUserInfo(state: SessionStateInterface) {
  return {
    ...state,
    error: undefined,
    expired: false,
    loading: true,
  };
}
function errorGetCurrentUserInfo(
  state: SessionStateInterface,
  action: ActionInterface<SessionActions>
) {
  return { ...state, error: action.payload, loading: false };
}

function successPinLogin(
  state: SessionStateInterface,
  action: ActionInterface<SessionActions, LoginResponse>
) {
  return {
    ...state,
    customer: get(action.payload, 'customer', undefined),
    expired: false,
    loading: false,
    redirectTo: undefined,
    token: get(action.payload, 'auth_token', ''),
  };
}
function startPinLogin(state: SessionStateInterface) {
  return { ...state, error: undefined, expired: false, loading: true };
}
function errorPinLogin(
  state: SessionStateInterface,
  action: ActionInterface<SessionActions>
) {
  return { ...state, error: action.payload, loading: false };
}
